module.exports = __webpack_public_path__ + "static/media/whatsapp.6bf18600.png";